


class loggedOperater {
        constructor(){
        this.klijent="";
        this.klijent_id=0;
        this.operater="";
        this.operater_id=0;
        this.uloga="";
        this.token="";
        this.logged=false;
        }
        odjava(){
            this.klijent="";
            this.klijent_id=0;
            this.operater="";
            this.operater_id=0;
            this.uloga="";
            this.token="";
            this.logged=false;
        }
    }

    class Govedo {
        constructor ({govedo_id=-1,zivbr="",ime="",datrod=new Date().toISOString().split("T")[0], spol="m",mzivbr="",ozivbr="",lokacija="",odjeljak_id=0,rfid="",pasmina_sifra="03",pasmina_naziv="OSTALI KRIŽANCI",putnica_oznaka=0,putnica_serbr=""}){
            this.govedo_id=govedo_id;
            this.zivbr=zivbr;
            this.ime=ime;
            this.datrod=datrod;
            this.spol=spol;
            this.mzivbr=mzivbr;
            this.ozivbr=ozivbr;
            this.lokacija=lokacija;
            this.odjeljak_id=odjeljak_id;
            this.rfid=rfid;
            this.pasmina_sifra=pasmina_sifra;
            this.pasmina_naziv=pasmina_naziv;
            this.putnica_oznaka=putnica_oznaka;
            this.putnica_serbr=putnica_serbr;
        }

        static emptyGovedo(){
            return new Govedo({govedo_id:-1,zivbr:"",ime:"",datrod:new Date().toISOString().split("T")[0], spol:"m",mzivbr:"",ozivbr:"",lokacija:"",odjeljak_id:0,rfid:"",pasmina_sifra:"03",pasmina_naziv:"OSTALI KRIŽANCI",putnica_oznaka:0});
        }
    }

    class DolazakData {
        constructor(knjiga_id=-1,datum=new Date().toISOString().split("T")[0],ijr=new Date().toISOString().split("T")[0],
        dokument_tip_id=0,dokument_broj="",uktezina="0.00",odjeljak_id=0,brgrla=1,govscansid=[],jibg="") {
            const d=new Date();
            this.knjiga_id=knjiga_id;
            this.datum=d.toISOString().split("T")[0];
            this.ijr=new Date(d.setDate(d.getDate()+1)).toISOString().split("T")[0];
            this.dokument_tip_id=dokument_tip_id;
            this.dokument_broj=dokument_broj;
            this.lokacija="";
            this.posjednik_naziv="";
            this.vlasnik_naziv="";
            this.uktezina=uktezina;
            this.odjeljak_id=odjeljak_id;
            this.brgrla=brgrla;
            this.uktezina=uktezina;
            this.govscansid=govscansid;
            this.jibg=jibg;
        }
        reset() {
            const d=new Date();
            this.knjiga_id=-1;
            this.datum=d.toISOString().split("T")[0];
            this.ijr=new Date(d.setDate(d.getDate()+1)).toISOString().split("T")[0];
            //this.ijr=new Date(24 * 3600 * 1000).toISOString().split("T")[0];
            this.dokument_tip_id=0;
            this.dokument_broj="";
            this.lokacija="";
            this.posjednik_naziv="";
            this.vlasnik_naziv="";
            this.uktezina="0.00";
            this.odjeljak_id=0;
            this.brgrla=1;
            this.jibg="";
        }
    }

    class OdlazakData {
        constructor(migracija_id=-1,migracija_tip_sifra='OKLA',knjiga_id=-1,datum=new Date().toISOString().split("T")[0],ijr=new Date().toISOString().split("T")[0],
        dokument_tip_id=0,dokument_broj="",uktezina="0.00",odjeljak_id=0,brgrla=1,migracijaPosjednik=new Osoba(),migracijaKnjigaId=-1,goveda=[],doldrzavacode="HR",verificiran=true,izlucenje=false,jibg="") {
            const d=new Date();
            this.migracija_tip_sifra=migracija_tip_sifra;
            this.migracija_id=migracija_id;
            this.knjiga_id=knjiga_id;
            this.datum=d.toISOString().split("T")[0];
            this.ijr=new Date(d.setDate(d.getDate()+1)).toISOString().split("T")[0];
            this.dokument_tip_id=dokument_tip_id;
            this.dokument_broj=dokument_broj;
            this.lokacija="";
            this.posjednik_naziv="";
            this.vlasnik_naziv="";
            this.uktezina=uktezina;
            this.odjeljak_id=odjeljak_id;
            this.brgrla=brgrla;
            this.uktezina=uktezina;
            this.migracijaPosjednik=migracijaPosjednik;
            this.migracijaKnjigaId=migracijaKnjigaId;
            this.doldrzavacode=doldrzavacode;
            this.verificiran=verificiran;
            this.izlucenje=izlucenje;
            this.goveda=[];
            this.jibg=jibg;
        }
        reset() {
            const d=new Date();
            this.migracija_id=-1;
            this.knjiga_id=-1;
            this.datum=d.toISOString().split("T")[0];
            this.ijr=new Date(d.setDate(d.getDate()+1)).toISOString().split("T")[0];
            //this.ijr=new Date(24 * 3600 * 1000).toISOString().split("T")[0];
            this.dokument_tip_id=0;
            this.dokument_broj="";
            this.lokacija="";
            this.posjednik_naziv="";
            this.vlasnik_naziv="";
            this.uktezina="0.00";
            this.odjeljak_id=0;
            this.brgrla=1;
            this.migracijaPosjednikId=new Osoba();
            this.migracijaPosjednikId=-1;
            this.doldrzavacode="HR";
            this.verificiran=true;
            this.izlucenje=false;
            this.jibg="";
        }
    }

    class Osoba {
        constructor(id=0,naziv="",mjesto="",ulkbr="",drzava="",sifra="",postanaziv="",pbr="",drzava_sifra=""){
            this.id=id;
            this.naziv=naziv;
            this.mjesto=mjesto;
            this.ulkbr=ulkbr;
            this.drzava=drzava;
            this.sifra=sifra;
            this.drzava_sifra=drzava_sifra;
            this.postanaziv=postanaziv;
            this.pbr=pbr;
            this.adresa=`${mjesto}, ${ulkbr}`;
            this.posta=`${pbr} ${postanaziv}`;
        }
    }
    //id:_r.id,naziv:_r.naziv,mjesto:_r.mjesto,ulkbr:_r.ulkbr,drzava:_r.drzava ,adresa:`${_r.mjesto}, ${_r.ulkbr}`,sifra:_r.sifra,posta:`${_r.pbr} ${_r.posta}
const colorSchmemes=["telegram","orange","yellow","green","teal","blue","cyan","purple","pink","linkedin","facebook","messenger","whatsapp","twitter","telegram","gray"];

let loggedOper=new loggedOperater();



const GruntComponentAction = {
    Create:'C',
    Read:'R',
    Edit:'E',
}

const GruntUloge={
    Admin:'a',
    Write:'w',
    Read:'r',
    Veter:'v',
}

const GruntGetRequestOptions = {
    method: 'GET',
    credentials:'same-origin',
    headers: { 'Content-Type': 'application/json' },
};

const GruntPostRequestOptions = {
    method: 'POST',
    credentials:'same-origin',
    headers: { 'Content-Type': 'application/json'},
};

const GruntPutRequestOptions = {
    method: 'PUT',
    credentials:'same-origin',
    headers: { 'Content-Type': 'application/json'},
};


const GetRequestOptions=(method="GET")=>{
    const requestOptions = {
        method: method,
        headers: { 'Content-Type': 'application/json','Authorization':loggedOper.token },
    };
    return requestOptions;
}

const numOfPages=(rowcount,rowsperpage)=>{
    let _rowcount=rowcount;
    if (rowcount%rowsperpage===0) {
        _rowcount=_rowcount-1;
    }
    let _r=(Math.floor(_rowcount/rowsperpage)+1);
    if (_r===0) {
        _r=1;
    }
    return _r;
}

const userCanEdit=()=>{
    //a=admin
    //w=write
    //r=read
    //v=veterinar
    if (loggedOper.uloga==="a" || loggedOper.uloga==="w") {
        return true;
    } else {
        return false;
    }
}

const userReadOnly=()=>{
    //a=admin
    //w=write
    //r=read
    //v=veterinar
    if (loggedOper.uloga==="a" || loggedOper.uloga==="w") {
        return false;
    } else {
        return true;
    }
}

const generateColor=()=>{
    const hexArray = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'A', 'B', 'C', 'D', 'E', 'F'];
    let code = "";
    for(let i=0; i<6; i++){
     code += hexArray[Math.floor(Math.random()*16)];
    }
    return `#${code}`
   }

   function getMonthDifference(startDate, endDate) {
    return (
      endDate.getMonth() -
      startDate.getMonth() +
      12 * (endDate.getFullYear() - startDate.getFullYear())
    );
  }

export {GruntComponentAction, GruntUloge,GruntGetRequestOptions, GruntPostRequestOptions,GruntPutRequestOptions, 
    loggedOper, colorSchmemes, GetRequestOptions, numOfPages, Govedo, DolazakData, OdlazakData,Osoba,userCanEdit,userReadOnly,generateColor,getMonthDifference}